// Print and Export utilities for WHIPT lists

export const printFilteredList = (
  categoryName: string,
  filterType: string,
  items: any[]
) => {
  const printWindow = window.open('', '_blank');
  if (!printWindow) return;

  const typeName = filterType === 'all' 
    ? categoryName 
    : filterType.replace('_', ' ').replace(/\b\w/g, l => l.toUpperCase());

  const html = `
<!DOCTYPE html>
<html>
<head>
  <title>WHIPT ${typeName} List</title>
  <style>
    @media print {
      @page { margin: 0.5in; }
      body { margin: 0; }
    }
    body {
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif;
      max-width: 8.5in;
      margin: 0 auto;
      padding: 20px;
      color: #1e293b;
    }
    .header {
      text-align: center;
      margin-bottom: 30px;
      padding-bottom: 20px;
      border-bottom: 3px solid #f59e0b;
    }
    .logo {
      font-size: 48px;
      font-weight: 900;
      color: #f59e0b;
      letter-spacing: 2px;
      margin-bottom: 5px;
    }
    .list-title {
      font-size: 24px;
      color: #475569;
      font-weight: 600;
    }
    .meta {
      font-size: 12px;
      color: #64748b;
      margin-top: 10px;
    }
    .item {
      padding: 12px 15px;
      margin: 8px 0;
      background: #f8fafc;
      border-left: 4px solid #f59e0b;
      border-radius: 4px;
      page-break-inside: avoid;
    }
    .item-title {
      font-weight: 600;
      font-size: 16px;
      margin-bottom: 5px;
    }
    .item-meta {
      font-size: 13px;
      color: #64748b;
    }
    .item-notes {
      font-size: 14px;
      color: #475569;
      margin-top: 5px;
      white-space: pre-wrap;
    }
    .checkbox {
      display: inline-block;
      width: 18px;
      height: 18px;
      border: 2px solid #cbd5e1;
      border-radius: 3px;
      margin-right: 10px;
      vertical-align: middle;
    }
    .footer {
      margin-top: 40px;
      padding-top: 20px;
      border-top: 1px solid #e2e8f0;
      text-align: center;
      font-size: 11px;
      color: #94a3b8;
    }
  </style>
</head>
<body>
  <div class="header">
    <div class="logo">WHIPT</div>
    <div class="list-title">${typeName} List</div>
    <div class="meta">Generated on ${new Date().toLocaleDateString('en-US', { 
      weekday: 'long', 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    })}</div>
  </div>
  
  <div class="items">
    ${items.map(item => `
      <div class="item">
        <div class="item-title">
          <span class="checkbox"></span>
          ${item.title}
        </div>
        ${item.dueDate ? `<div class="item-meta">Due: ${new Date(item.dueDate).toLocaleString()}</div>` : ''}
        ${item.description || item.notes ? `<div class="item-notes">${item.description || item.notes}</div>` : ''}
      </div>
    `).join('')}
  </div>
  
  <div class="footer">
    Printed from WHIPT • ${items.length} item${items.length === 1 ? '' : 's'}
  </div>
  
  <script>
    window.onload = () => {
      window.print();
      // Auto-close after print dialog is closed (optional)
      // setTimeout(() => window.close(), 1000);
    };
  </script>
</body>
</html>
  `;

  printWindow.document.write(html);
  printWindow.document.close();
};

export const downloadFilteredList = (
  categoryName: string,
  filterType: string,
  items: any[]
) => {
  const typeName = filterType === 'all' 
    ? categoryName 
    : filterType.replace('_', ' ').replace(/\b\w/g, l => l.toUpperCase());

  const content = `WHIPT ${typeName} List
Generated: ${new Date().toLocaleString()}
${'='.repeat(50)}

${items.map((item, i) => `
${i + 1}. ${item.title}
   ${item.dueDate ? `Due: ${new Date(item.dueDate).toLocaleString()}\n   ` : ''}${item.description || item.notes || ''}
`).join('\n')}

${'='.repeat(50)}
Total: ${items.length} item${items.length === 1 ? '' : 's'}
`;

  const blob = new Blob([content], { type: 'text/plain' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `whipt-${typeName.toLowerCase().replace(/\s+/g, '-')}-${new Date().toISOString().split('T')[0]}.txt`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
